import React, { useContext, useState } from 'react';
import { Text, View, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faEye } from '@fortawesome/free-solid-svg-icons';

// import SubNav from './SubNav';
import SubNav from '../../elements/SubNav';
import { Link } from 'app/src/utils/routing';
import NewInvoice from 'app/src/components/Accounting/Invoices/new';
import Invoice from 'app/src/components/Accounting/Invoices/show';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   PageTitle,
   LinkContainer,
   TableNavbarContainer,
   LinkSpace,
   SubNavContainer
} from '../../elements';
import Modal from '../../elements/Modal';
import EditFee from './edit';
import { formatAssetNameForSelect } from '../../utils/formatAssetName';
import currencyFormatter from '../../utils/currencyFormatter';
import AuthContext from 'app/src/contexts/AuthContext';
import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import { createReport } from '../../elements/ReportCreate';
import FileDownload from 'js-file-download';
import { elRed } from '../../styles/colors';
import { dateShort } from 'app/src/utils/timeFormatter';

import { STATUSES } from './elements';
import FeeEstimates from './FeeEstimates';
import NewFee from './new';
import { FEES_WITH_COUNT, HIDE_FEE } from './queries';

const inputStyle = {
  marginBottom: '10px'
}

const INVOICE_STATUSES = {
  pending: 'Not Invoiced',
  fee_invoice: 'Fee Invoice',
  buyer_invoice: 'Buyer Invoice',
  seller_ach: 'Seller ACH',
};

const Fees = (props) => {
  const { asset, fromSalesProcess, refetchAsset } = props;
  const [refetch, setRefetch] = useState();
  const [clickedFee, setClickedFee] = useState();
  const [showAddFeeModal, setShowAddFeeModal] = useState(false);
  const [showEditFeeModal, setShowEditFeeModal] = useState(false);
  const [showNewInvoice, setShowNewInvoice] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);

  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const { hasPolicy, credentials } = useContext(AuthContext);
  const [pdfFeeIds, setPdfFeeIds] = useState([]);
  const [showReportCreated, setShowReportCreated] = useState(false);

  const queryVariables = {
    assetId: asset?.id,
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };
  const [hideFee] = useMutation(
    HIDE_FEE, { onCompleted: refetch }
  )

  const onHide = (feeId) => {
    hideFee({ variables: { id: feeId }});
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  const handleChange = (value) => {
    let newPdfFeeIds = [];
    if(!pdfFeeIds.includes(value)) {
      newPdfFeeIds = [...pdfFeeIds, value];
    }else {
      newPdfFeeIds = pdfFeeIds.filter(id => id !== value)
    }

    setPdfFeeIds(newPdfFeeIds);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const handleCreate = () => {
    createReport({
      credentials: credentials,
      params: { 'assetId': asset.id, 'feeIds': JSON.stringify(pdfFeeIds) },
      onCompleted: () => {
        setShowReportCreated(true);
        if (refetchAsset) { refetchAsset(); }
      }
    });
  };

  const columns = asset ?
    [
      {
        key: 'addToPdf',
        label: 'Add to Fee Report',
        content: entry => {
          return (
            <input
              type='checkbox'
              checked={pdfFeeIds.includes(parseInt(entry.entry.id))}
              onChange={() => handleChange(parseInt(entry.entry.id))}
            />
          )
        }
      },
      {
        key: 'createdAt',
        label: 'Date Entered',
        content: dateShort,
      },
      {
        key: 'type',
        label: 'Type',
        content: (entry) => {
          return entry.entry.type
        }
      },
      {
        key: 'buyerFee',
        label: 'Buyer Fee?',
        content: (entry) => {
          return entry.entry.buyerFee ? 'Yes' : 'No'
        }
      },
      // {
      //   key: 'saleAsset',
      //   label: 'Sale Asset',
      //   // width: '20%',
      //   content: (entry) => {
      //     return entry.entry.saleAsset.id
      //   }
      // },
      {
        key: 'amount',
        label: 'Amount',
        content: (entry) => {
          return currencyFormatter(entry.entry.amount);
        }
      },
      {
        key: 'description',
        label: 'Description',
        content: (entry) => {
          return entry.entry.description
        }
      },
      {
        key: 'createdByName',
        label: 'Added By',
        value: ({ entry, value }) => 'Sell' == entry.type ? null : value
      },
      // <View>
      //     {
      //       entry.upload ? (
      //         <Link to={entry.upload.url} target='_blank'>
      //           <Text>
      //             {entry.upload.filename}
      //           </Text>
      //         </Link>
      //       ) :
      //       <Link to={entry.linkedAttachment?.url} target='_blank'>
      //         <Text>
      //           {`${entry.linkedAttachment?.name} (linked)`}
      //         </Text>
      //       </Link>
      //     }
      //   </View>
      {
        key: 'files',
        label: 'Files',
        content: (entry) => {
          return (
            <View>
              {entry.entry.feeFiles.map(file => {
                return(
                  <View>
                    <Link to={file.url} target='_blank'>
                      <Text>
                        {file.filename}
                      </Text>
                    </Link>
                  </View>
                )
              })}
              {entry.entry.linkedAttachments.map(file => {
                return (
                  <View>
                    <Link to={file.url} target='_blank'>
                      <Text>
                        {`${file.name} (linked)`}
                      </Text>
                    </Link>
                  </View>
                )
              })}
            </View>
          )
        }
      },
      {
        key: 'feeEstimate',
        label: 'From Estimate?',
        content: (entry) => {
          if(entry.entry.feeEstimate) {
            return (
              <View>
                <Text>
                  {`${entry.value.acceptedByString} accepted by ${entry.entry.acceptedByMethod}`}
                </Text>
              </View>
            )
          }
        }
      },
      {
        key: 'invoiceStatus',
        label: 'Invoice Status',
        content: ({ entry, value }) => (
          <View style={{ flexDirection: 'row', gap: 10 }}>
            <Text>{INVOICE_STATUSES[value]}</Text>
            {['buyer_invoice', 'fee_invoice'].includes(value) && (
              <Text>{entry.invoiceTxn?.reference}</Text>
            )}
            {'seller_ach' !== value && (
              <>
                {entry.invoiceTxn ? (
                  <Pressable onPress={() => setShowInvoice(entry)}>
                    <FontAwesomeIcon
                      icon={faEye}
                      title="View Invoice"
                    />
                  </Pressable>
                ) : (
                  <Pressable onPress={() => setShowNewInvoice(entry)}>
                    <FontAwesomeIcon
                      icon={faCirclePlus}
                      title="Create Invoice"
                    />
                  </Pressable>
                )}
              </>
            )}
          </View>
        ),
      },
      {
        key: 'functions',
        label: 'Functions',
        sort: 'prevent',
        content: (entry) => {
          if (!hasPolicy({ type: 'Fee', action: 'update' })) {
            return null;
          }

          return (
            <LinkContainer>
              <Pressable
                onPress={() => {
                  setClickedFee(entry.entry);
                  setShowEditFeeModal(true)
                }}
                style={{marginLeft: '10px'}}
                key={`sale-fee-link-${entry.entry.id}`}
                name={`sale-fee-link-${entry.entry.id}`}
              >
                <Text>
                  Edit
                </Text>
              </Pressable>
            </LinkContainer>
          )
        }
      }
    ] :
    [
      {
        key: 'type',
        label: 'Type',
        content: (entry) => {
          return entry.entry.type
        }
      },
      {
        key: 'buyerFee',
        label: 'Buyer Fee?',
        content: (entry) => {
          return entry.entry.buyerFee ? 'Yes' : 'No'
        }
      },
      {
        key: 'assetId',
        label: 'Asset',
        content: (entry) => {
          return formatAssetNameForSelect(entry.entry.asset)
        }
      },
      // {
      //   key: 'saleAsset',
      //   label: 'Sale Asset',
      //   // width: '20%',
      //   content: (entry) => {
      //     return entry.entry.saleAsset.id
      //   }
      // },
      {
        key: 'amount',
        label: 'Amount',
        content: (entry) => {
          return currencyFormatter(entry.entry.amount);
        }
      },
      {
        key: 'description',
        label: 'Description',
        content: (entry) => {
          return entry.entry.description
        }
      },
      {
        key: 'functions',
        label: 'Functions',
        sort: 'prevent',
        content: (entry) => {
          return (
            <LinkContainer>
              <Pressable
                onPress={() => {
                  setClickedFee(entry.entry);
                  setShowEditFeeModal(true)
                }}
                style={{marginLeft: '10px'}}
                key={`sale-fee-link-${entry.entry.id}`}
                name={`sale-fee-link-${entry.entry.id}`}
              >
                <Text>
                  Edit
                </Text>
              </Pressable>
            </LinkContainer>
          )
        }
      }
    ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        {/* <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Type:</Text>
          <select
            type={'select'}
            name="type"
            onChange={e => setFilter('type', e.target.value)}
            value={filters.type || ''}
          >
            <option key={`status-all`}>
              {'All'}
            </option>
            {TYPES.map(type =>
              <option key={`type-${type}`}>
                {type}
              </option>
            )}
          </select>

        </View> */}
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      {showReportCreated &&
        <div
          style={{padding: '10px', backgroundColor: elRed, color: '#fff',
            fontWeight: 'bold'
          }}
        >
          Fee Report created. The file is in the Seller Notes/Documents tab.
        </div>
      }
      <ContentContainer>
        <PageTitle>Fees</PageTitle>
        <br /><br />
        <TableContainer>
          {getSubNavContents()}
          <DataTable.Gql
            setRefetch={setRefetch}
            query={FEES_WITH_COUNT}
            queryName='feesWithCount'
            columns={columns}
            // buttons={buttons}
            lengthMenu={ [10, 25, 50, 'All'] }
            setSettings={setSettings}
            dataUpdated={data => setFilterOptions(data?.feesWithCount)}
            htmlTable
            queryVariables={queryVariables}
          />
        </TableContainer>
      </ContentContainer>
      {!fromSalesProcess &&
        <FeeEstimates asset={asset} feeRefetch={refetch} />
      }
      {showEditFeeModal &&
        <Modal
          refetch={refetch}
          showModal={showEditFeeModal}
          setShowModal={setShowEditFeeModal}
          modalType={'Edit Fee'}
          objectName={clickedFee.name}
        >
          <EditFee
            setShowModal={setShowEditFeeModal}
            refetch={refetch}
            fee={clickedFee}
            asset={asset}
            fromSalesProcess={fromSalesProcess}
          />
        </Modal>
      }
      {showNewInvoice &&
        <Modal
          showModal={showNewInvoice}
          setShowModal={setShowNewInvoice}
          modalType="Create Invoice"
          objectName={showNewInvoice.asset.stockNumber}
        >
          <NewInvoice
            fee={showNewInvoice}
            asset={asset}
            setShowModal={setShowNewInvoice}
            onCompleted={txn => {
              setShowInvoice({...showNewInvoice, invoiceTxn: txn});
              setShowNewInvoice(false);
              refetch();
            }}
          />
        </Modal>
      }
      {showInvoice &&
        <Modal
          showModal={showInvoice}
          setShowModal={setShowInvoice}
          modalType="Invoice Detail"
          objectName={showInvoice.asset.stockNumber}
        >
          <Invoice
            id={showInvoice.invoiceTxn.id}
            setShowModal={setShowInvoice}
          />
        </Modal>
      }
    </MainContainer>
  )

  function getSubNavContents() {
    return (
      <SubNavContainer>
        {getLinks()}
      </SubNavContainer>
    )
    function getLinks() {
      if (!hasPolicy({ type: 'Fee', action: 'create' })) {
        return null;
      }

      return (
        <View style={{display: 'flex', flexDirection: 'row'}}>
          <Pressable
            onPress={() => setShowAddFeeModal(true)}
          >
            <Text>+ Add Fee</Text>
          </Pressable>
          <Pressable
            onPress={() => {
              if(window.confirm('Create Fee Report')) {
                handleCreate();
            }}}
            style={{marginLeft: '20px'}}
            disabled={!pdfFeeIds?.length}
          >
            <Text
              style={{opacity: pdfFeeIds?.length ? 1 : 0.25}}
            >
              Create Fee PDF
            </Text>
          </Pressable>
          {showAddFeeModal &&
            <Modal
              showModal={showAddFeeModal}
              setShowModal={setShowAddFeeModal}
              modalType={'Add Fee'}
            >
              <NewFee
                setShowModal={setShowAddFeeModal}
                refetch={refetch}
                knownAsset={asset}
                fromSalesProcess={fromSalesProcess}
              />
            </Modal>
          }
        </View>
      )
    }
  }
}

export default Fees;
